import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { useUniquePrefix } from "../../../hooks/useUniquePrefix";
var Error404 = function(param) {
    var width = param.width, height = param.height, title = param.title;
    var uniqueID = useUniquePrefix();
    return _jsxs("svg", {
        width: width,
        height: height,
        viewBox: "0 0 390 306",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            _jsx("title", {
                children: title
            }),
            _jsxs("defs", {
                children: [
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-1"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#00A7FA"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#0076F3"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "-2.48949813e-15%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-4"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#0096F7"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#00FFD6"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-5"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#DA66FF"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#9B66FF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "-2.48949813e-15%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-8"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#D266FF"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFA6FA"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "17.0717178%",
                        y1: "0%",
                        x2: "94.9709961%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-9"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-12"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#F09A13"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FBFF00"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "17.3308599%",
                        y1: "0%",
                        x2: "94.617079%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-13"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-16"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#F09A13"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FBFF00"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "18.5108516%",
                        y1: "0%",
                        x2: "93.0055343%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-17"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-20"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#F09A13"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FBFF00"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "20.7930444%",
                        y1: "0%",
                        x2: "89.8886852%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-21"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-24"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#F09A13"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FBFF00"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "0%",
                        y1: "47.3096885%",
                        x2: "73.3674654%",
                        y2: "51.1491315%",
                        id: "".concat(uniqueID, "Error404-linearGradient-25"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "97.6810874%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0.4"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "47.3623144%",
                        y1: "45.3715475%",
                        x2: "58.4902924%",
                        y2: "53.6056578%",
                        id: "".concat(uniqueID, "Error404-linearGradient-28"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0.81"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "3.0565022%",
                        y1: "3.81578571%",
                        x2: "3.0565022%",
                        y2: "100%",
                        id: "".concat(uniqueID, "Error404-linearGradient-29"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#E1E1E1"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsx("path", {
                        d: "M107.317694,36.1490721 C-0.0706708277,87.2912512 37.6064892,185.189902 116.823606,229.648412 C196.040723,274.106922 371.761597,147.768594 280.246867,107.964225 C188.732136,68.1598558 214.706059,-14.9931071 107.317694,36.1490721 Z",
                        id: "".concat(uniqueID, "Error404-path-2")
                    }),
                    _jsx("path", {
                        d: "M115.312585,36.1490721 C16.0290024,87.2912512 50.8626032,185.189902 124.10107,229.648412 C197.339537,274.106922 359.798458,147.768594 275.190499,107.964225 C190.582541,68.1598558 214.596168,-14.9931071 115.312585,36.1490721 Z",
                        id: "".concat(uniqueID, "Error404-path-6")
                    }),
                    _jsx("path", {
                        d: "M10.7672503,0.844840466 C10.829903,0.884463206 10.8829613,0.937521505 10.922584,1.00017413 L13.7704786,5.50334782 L14.9295943,7.49336008 L15.6255819,7.89010345 L19.9672943,10.5747317 C20.2021635,10.7199593 20.2748324,11.0280886 20.1296048,11.2629579 C20.0888205,11.3289163 20.0332528,11.384484 19.9672943,11.4252683 L15.6255819,14.1098965 L14.9295943,14.5053601 L13.7704786,16.4966522 L10.922584,20.9998259 C10.7749857,21.2332126 10.4661364,21.3027578 10.2327497,21.1551595 C10.170097,21.1155368 10.1170387,21.0624785 10.077416,20.9998259 L7.22952138,16.4966522 L6.06959432,14.5053601 L5.37441809,14.1098965 L1.03270567,11.4252683 C0.966747212,11.384484 0.911179542,11.3289163 0.870395186,11.2629579 C0.725167571,11.0280886 0.797836452,10.7199593 1.03270567,10.5747317 L1.03270567,10.5747317 L5.37441809,7.89010345 L6.06959432,7.49336008 L7.22952138,5.50334782 L10.077416,1.00017413 C10.2250143,0.766787425 10.5338636,0.697242173 10.7672503,0.844840466 Z",
                        id: "".concat(uniqueID, "Error404-path-10")
                    }),
                    _jsx("path", {
                        d: "M17.7661364,0.771474961 C17.8296457,0.811405709 17.8833557,0.865115709 17.9232865,0.928625048 L23.0606597,9.09955067 L25.0314271,12.5026958 L26.2148151,13.1814126 L34.0835739,18.0754207 C34.3180626,18.2212619 34.3899255,18.5295802 34.2440843,18.7640689 C34.2035941,18.8291705 34.1486755,18.8840891 34.0835739,18.9245793 L26.2148151,23.8185874 L25.0314271,24.4956958 L23.0606597,27.9004493 L17.9232865,36.071375 C17.7763034,36.3051496 17.4676383,36.3755081 17.2338636,36.228525 C17.1703543,36.1885943 17.1166443,36.1348843 17.0767135,36.071375 L11.9393403,27.9004493 L9.96742709,24.4946958 L8.78518486,23.8185874 L0.916426132,18.9245793 C0.851324546,18.8840891 0.796405937,18.8291705 0.755915729,18.7640689 C0.61007449,18.5295802 0.681937445,18.2212619 0.916426132,18.0754207 L0.916426132,18.0754207 L8.78518486,13.1814126 L9.96742709,12.5036958 L11.9393403,9.09955067 L17.0767135,0.928625048 C17.2236966,0.69485039 17.5323617,0.624491899 17.7661364,0.771474961 Z",
                        id: "".concat(uniqueID, "Error404-path-14")
                    }),
                    _jsx("path", {
                        d: "M13.2624863,0.141814563 C13.3288087,0.182722394 13.3846517,0.238565455 13.4255596,0.30488785 L17.3011024,6.588166 L18.8255182,9.2723044 L19.7408031,9.80653165 L25.6891417,13.5777158 C25.9223629,13.7255755 25.9915619,14.0345026 25.8437022,14.2677238 C25.8042117,14.3300126 25.7514305,14.3827938 25.6891417,14.4222842 L19.7408031,18.1934684 L18.8255182,18.7273044 L17.3011024,21.411834 L13.4255596,27.6951122 C13.2805924,27.9301422 12.9725438,28.0031526 12.7375137,27.8581854 C12.6711913,27.8172776 12.6153483,27.7614345 12.5744404,27.6951122 L8.69889761,21.411834 L7.17351819,18.7273044 L6.25919685,18.1934684 L0.310858293,14.4222842 C0.248569493,14.3827938 0.195788264,14.3300126 0.15629782,14.2677238 C0.00843806412,14.0345026 0.0776371448,13.7255755 0.310858293,13.5777158 L0.310858293,13.5777158 L6.25919685,9.80653165 L7.17351819,9.2723044 L8.69889761,6.588166 L12.5744404,0.30488785 C12.7194076,0.0698577875 13.0274562,-0.00315261002 13.2624863,0.141814563 Z",
                        id: "".concat(uniqueID, "Error404-path-18")
                    }),
                    _jsx("path", {
                        d: "M13.754854,0.295109513 C13.8270864,0.337903199 13.88738,0.398196784 13.9301737,0.470429183 L17.881279,7.13958623 L19.4334222,9.98520502 L20.3664581,10.5527341 L26.4719598,14.582706 C26.702425,14.7348258 26.7659364,15.0449722 26.6138165,15.2754373 C26.5766002,15.3318209 26.5283435,15.3800777 26.4719598,15.417294 L20.3664581,19.4472659 L19.4334222,20.014205 L17.881279,22.8604138 L13.9301737,29.5295708 C13.7894217,29.7671492 13.4827243,29.8456425 13.245146,29.7048905 C13.1729136,29.6620968 13.11262,29.6018032 13.0698263,29.5295708 L9.11872102,22.8604138 L7.56542222,20.013205 L6.63354194,19.4472659 L0.528040152,15.417294 C0.471656548,15.3800777 0.423399804,15.3318209 0.386183479,15.2754373 C0.234063645,15.0449722 0.297575041,14.7348258 0.528040152,14.582706 L0.528040152,14.582706 L6.63354194,10.5527341 L7.56542222,9.98520502 L9.11872102,7.13958623 L13.0698263,0.470429183 C13.2105783,0.232850804 13.5172757,0.154357514 13.754854,0.295109513 Z",
                        id: "".concat(uniqueID, "Error404-path-22")
                    }),
                    _jsx("path", {
                        d: "M58.7621145,188 C57.7283355,188 56.8355397,187.619051 56.0837004,186.857143 C55.3318611,186.095234 54.9559471,185.190481 54.9559471,184.142857 L54.9559471,172 L12.8061674,172 C11.7723884,172 10.8795926,171.619051 10.1277533,170.857143 C9.37591401,170.095234 9,169.190481 9,168.142857 L9,147.714286 C9,146.09523 9.51688176,144.619054 10.5506608,143.285714 L50.4449339,90.4285714 C51.7606527,88.8095157 53.499255,88 55.660793,88 L84.9823789,88 C86.0161579,88 86.9089537,88.3809486 87.660793,89.1428571 C88.4126322,89.9047657 88.7885463,90.8095186 88.7885463,91.8571429 L88.7885463,143 L101.052863,143 C102.180622,143 103.120407,143.380949 103.872247,144.142857 C104.624086,144.904766 105,145.809519 105,146.857143 L105,168.142857 C105,169.190481 104.624086,170.095234 103.872247,170.857143 C103.120407,171.619051 102.227612,172 101.193833,172 L88.7885463,172 L88.7885463,184.142857 C88.7885463,185.190481 88.4126322,186.095234 87.660793,186.857143 C86.9089537,187.619051 86.0161579,188 84.9823789,188 L58.7621145,188 Z M40,145 L56,145 L56,125 L40,145 Z M160,189 C146.277534,188.905555 135.630953,185.552811 128.059937,178.941667 C120.488921,172.330523 116.277607,163.594499 115.425868,152.733333 C115.141954,148.861092 115,143.902808 115,137.858333 C115,131.719414 115.141954,126.666687 115.425868,122.7 C115.899056,115.711076 117.957395,109.548638 121.600946,104.2125 C125.244498,98.8763622 130.354857,94.6736265 136.932177,91.6041667 C143.509497,88.5347069 151.198694,87 160,87 C168.801306,87 176.490503,88.5347069 183.067823,91.6041667 C189.645143,94.6736265 194.755502,98.8763622 198.399054,104.2125 C202.042605,109.548638 204.100944,115.711076 204.574132,122.7 C204.858046,126.666687 205,131.719414 205,137.858333 C205,143.902808 204.858046,148.861092 204.574132,152.733333 C203.722393,163.594499 199.511079,172.330523 191.940063,178.941667 C184.369047,185.552811 173.722466,188.905555 160,189 Z M160,161 C164.761929,161 167.333331,157.923495 167.714286,151.770393 C167.904763,149.025163 168,144.244747 168,137.429003 C168,130.518596 167.904763,125.785511 167.714286,123.229607 C167.333331,117.171168 164.761929,114.094663 160,114 C155.238071,114.094663 152.666669,117.171168 152.285714,123.229607 C152.095237,128.341415 152,133.0745 152,137.429003 C152,141.499517 152.095237,146.279932 152.285714,151.770393 C152.666669,157.923495 155.238071,161 160,161 Z M265.762115,188 C264.728336,188 263.83554,187.619051 263.0837,186.857143 C262.331861,186.095234 261.955947,185.190481 261.955947,184.142857 L261.955947,172 L219.806167,172 C218.772388,172 217.879593,171.619051 217.127753,170.857143 C216.375914,170.095234 216,169.190481 216,168.142857 L216,147.714286 C216,146.09523 216.516882,144.619054 217.550661,143.285714 L257.444934,90.4285714 C258.760653,88.8095157 260.499255,88 262.660793,88 L291.982379,88 C293.016158,88 293.908954,88.3809486 294.660793,89.1428571 C295.412632,89.9047657 295.788546,90.8095186 295.788546,91.8571429 L295.788546,143 L308.052863,143 C309.180622,143 310.120407,143.380949 310.872247,144.142857 C311.624086,144.904766 312,145.809519 312,146.857143 L312,168.142857 C312,169.190481 311.624086,170.095234 310.872247,170.857143 C310.120407,171.619051 309.227612,172 308.193833,172 L295.788546,172 L295.788546,184.142857 C295.788546,185.190481 295.412632,186.095234 294.660793,186.857143 C293.908954,187.619051 293.016158,188 291.982379,188 L265.762115,188 Z M247,145 L263,145 L263,125 L247,145 Z",
                        id: "".concat(uniqueID, "Error404-path-26")
                    }),
                    _jsxs("filter", {
                        x: "-23.0%",
                        y: "-19.2%",
                        width: "146.0%",
                        height: "157.5%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "Error404-filter-3"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "23",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "4",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "16.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "9",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-24.9%",
                        y: "-19.2%",
                        width: "149.8%",
                        height: "157.5%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "Error404-filter-7"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "23",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "4",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "16.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "9",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.607843137 0 0 0 0 0.4 0 0 0 0 1 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.607843137 0 0 0 0 0.4 0 0 0 0 1 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-314.3%",
                        y: "-205.2%",
                        width: "728.6%",
                        height: "715.7%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "Error404-filter-11"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "23",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "4",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "16.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "9",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-181.3%",
                        y: "-117.9%",
                        width: "462.7%",
                        height: "453.8%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "Error404-filter-15"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "23",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "4",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "16.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "9",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-236.0%",
                        y: "-150.7%",
                        width: "572.1%",
                        height: "552.2%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "Error404-filter-19"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "23",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "4",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "16.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "9",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-231.1%",
                        y: "-142.1%",
                        width: "562.2%",
                        height: "526.4%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "Error404-filter-23"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "23",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "4",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "16.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "9",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-12.4%",
                        y: "-31.9%",
                        width: "138.0%",
                        height: "227.5%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "Error404-filter-27"),
                        children: [
                            _jsx("feOffset", {
                                dx: "20",
                                dy: "40",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "12.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
                                type: "matrix",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    })
                ]
            }),
            _jsx("g", {
                stroke: "none",
                fill: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: _jsx("g", {
                    id: "".concat(uniqueID, "Error404-Hero/Error/404-Error"),
                    transform: "translate(1.000000, -45.000000)",
                    children: _jsxs("g", {
                        transform: "translate(32.000000, 46.000000)",
                        children: [
                            _jsx("path", {
                                d: "M90.3125852,41.1490721 C-8.97099756,92.2912512 25.8626032,190.189902 99.1010699,234.648412 C172.339537,279.106922 334.798458,152.768594 250.190499,112.964225 C165.582541,73.1598558 189.596168,-9.99310708 90.3125852,41.1490721 Z",
                                stroke: "#E1E1E1",
                                strokeWidth: "0.537974684"
                            }),
                            _jsx("path", {
                                d: "M123.06233,16.1490721 C24.1839861,67.2912512 58.8754089,165.189902 131.814943,209.648412 C204.754477,254.106922 366.550301,127.768594 282.287681,87.9642249 C198.025061,48.1598558 221.940673,-34.9931071 123.06233,16.1490721 Z",
                                stroke: "#E1E1E1",
                                strokeWidth: "0.537974684"
                            }),
                            _jsx("path", {
                                d: "M107.317694,36.1490721 C-0.0706708277,87.2912512 37.6064892,185.189902 116.823606,229.648412 C196.040723,274.106922 371.761597,147.768594 280.246867,107.964225 C188.732136,68.1598558 214.706059,-14.9931071 107.317694,36.1490721 Z",
                                stroke: "url(#".concat(uniqueID, "Error404-linearGradient-4)"),
                                strokeWidth: "2"
                            }),
                            _jsx("path", {
                                d: "M115.312585,36.1490721 C16.0290024,87.2912512 50.8626032,185.189902 124.10107,229.648412 C197.339537,274.106922 359.798458,147.768594 275.190499,107.964225 C190.582541,68.1598558 214.596168,-14.9931071 115.312585,36.1490721 Z",
                                stroke: "url(#".concat(uniqueID, "Error404-linearGradient-8)"),
                                strokeWidth: "2"
                            }),
                            _jsx("path", {
                                d: "M58.7621145,188 C57.7283355,188 56.8355397,187.619051 56.0837004,186.857143 C55.3318611,186.095234 54.9559471,185.190481 54.9559471,184.142857 L54.9559471,172 L12.8061674,172 C11.7723884,172 10.8795926,171.619051 10.1277533,170.857143 C9.37591401,170.095234 9,169.190481 9,168.142857 L9,147.714286 C9,146.09523 9.51688176,144.619054 10.5506608,143.285714 L50.4449339,90.4285714 C51.7606527,88.8095157 53.499255,88 55.660793,88 L84.9823789,88 C86.0161579,88 86.9089537,88.3809486 87.660793,89.1428571 C88.4126322,89.9047657 88.7885463,90.8095186 88.7885463,91.8571429 L88.7885463,143 L101.052863,143 C102.180622,143 103.120407,143.380949 103.872247,144.142857 C104.624086,144.904766 105,145.809519 105,146.857143 L105,168.142857 C105,169.190481 104.624086,170.095234 103.872247,170.857143 C103.120407,171.619051 102.227612,172 101.193833,172 L88.7885463,172 L88.7885463,184.142857 C88.7885463,185.190481 88.4126322,186.095234 87.660793,186.857143 C86.9089537,187.619051 86.0161579,188 84.9823789,188 L58.7621145,188 Z M40,145 L56,145 L56,125 L40,145 Z M160,189 C146.277534,188.905555 135.630953,185.552811 128.059937,178.941667 C120.488921,172.330523 116.277607,163.594499 115.425868,152.733333 C115.141954,148.861092 115,143.902808 115,137.858333 C115,131.719414 115.141954,126.666687 115.425868,122.7 C115.899056,115.711076 117.957395,109.548638 121.600946,104.2125 C125.244498,98.8763622 130.354857,94.6736265 136.932177,91.6041667 C143.509497,88.5347069 151.198694,87 160,87 C168.801306,87 176.490503,88.5347069 183.067823,91.6041667 C189.645143,94.6736265 194.755502,98.8763622 198.399054,104.2125 C202.042605,109.548638 204.100944,115.711076 204.574132,122.7 C204.858046,126.666687 205,131.719414 205,137.858333 C205,143.902808 204.858046,148.861092 204.574132,152.733333 C203.722393,163.594499 199.511079,172.330523 191.940063,178.941667 C184.369047,185.552811 173.722466,188.905555 160,189 Z M160,161 C164.761929,161 167.333331,157.923495 167.714286,151.770393 C167.904763,149.025163 168,144.244747 168,137.429003 C168,130.518596 167.904763,125.785511 167.714286,123.229607 C167.333331,117.171168 164.761929,114.094663 160,114 C155.238071,114.094663 152.666669,117.171168 152.285714,123.229607 C152.095237,128.341415 152,133.0745 152,137.429003 C152,141.499517 152.095237,146.279932 152.285714,151.770393 C152.666669,157.923495 155.238071,161 160,161 Z M265.762115,188 C264.728336,188 263.83554,187.619051 263.0837,186.857143 C262.331861,186.095234 261.955947,185.190481 261.955947,184.142857 L261.955947,172 L219.806167,172 C218.772388,172 217.879593,171.619051 217.127753,170.857143 C216.375914,170.095234 216,169.190481 216,168.142857 L216,147.714286 C216,146.09523 216.516882,144.619054 217.550661,143.285714 L257.444934,90.4285714 C258.760653,88.8095157 260.499255,88 262.660793,88 L291.982379,88 C293.016158,88 293.908954,88.3809486 294.660793,89.1428571 C295.412632,89.9047657 295.788546,90.8095186 295.788546,91.8571429 L295.788546,143 L308.052863,143 C309.180622,143 310.120407,143.380949 310.872247,144.142857 C311.624086,144.904766 312,145.809519 312,146.857143 L312,168.142857 C312,169.190481 311.624086,170.095234 310.872247,170.857143 C310.120407,171.619051 309.227612,172 308.193833,172 L295.788546,172 L295.788546,184.142857 C295.788546,185.190481 295.412632,186.095234 294.660793,186.857143 C293.908954,187.619051 293.016158,188 291.982379,188 L265.762115,188 Z M247,145 L263,145 L263,125 L247,145 Z",
                                fill: "url(#".concat(uniqueID, "Error404-linearGradient-28)"),
                                opacity: "0.648321243"
                            }),
                            _jsx("path", {
                                d: "M58.7621145,188 C57.7283355,188 56.8355397,187.619051 56.0837004,186.857143 C55.3318611,186.095234 54.9559471,185.190481 54.9559471,184.142857 L54.9559471,172 L12.8061674,172 C11.7723884,172 10.8795926,171.619051 10.1277533,170.857143 C9.37591401,170.095234 9,169.190481 9,168.142857 L9,147.714286 C9,146.09523 9.51688176,144.619054 10.5506608,143.285714 L50.4449339,90.4285714 C51.7606527,88.8095157 53.499255,88 55.660793,88 L84.9823789,88 C86.0161579,88 86.9089537,88.3809486 87.660793,89.1428571 C88.4126322,89.9047657 88.7885463,90.8095186 88.7885463,91.8571429 L88.7885463,143 L101.052863,143 C102.180622,143 103.120407,143.380949 103.872247,144.142857 C104.624086,144.904766 105,145.809519 105,146.857143 L105,168.142857 C105,169.190481 104.624086,170.095234 103.872247,170.857143 C103.120407,171.619051 102.227612,172 101.193833,172 L88.7885463,172 L88.7885463,184.142857 C88.7885463,185.190481 88.4126322,186.095234 87.660793,186.857143 C86.9089537,187.619051 86.0161579,188 84.9823789,188 L58.7621145,188 Z M40,145 L56,145 L56,125 L40,145 Z M160,189 C146.277534,188.905555 135.630953,185.552811 128.059937,178.941667 C120.488921,172.330523 116.277607,163.594499 115.425868,152.733333 C115.141954,148.861092 115,143.902808 115,137.858333 C115,131.719414 115.141954,126.666687 115.425868,122.7 C115.899056,115.711076 117.957395,109.548638 121.600946,104.2125 C125.244498,98.8763622 130.354857,94.6736265 136.932177,91.6041667 C143.509497,88.5347069 151.198694,87 160,87 C168.801306,87 176.490503,88.5347069 183.067823,91.6041667 C189.645143,94.6736265 194.755502,98.8763622 198.399054,104.2125 C202.042605,109.548638 204.100944,115.711076 204.574132,122.7 C204.858046,126.666687 205,131.719414 205,137.858333 C205,143.902808 204.858046,148.861092 204.574132,152.733333 C203.722393,163.594499 199.511079,172.330523 191.940063,178.941667 C184.369047,185.552811 173.722466,188.905555 160,189 Z M160,161 C164.761929,161 167.333331,157.923495 167.714286,151.770393 C167.904763,149.025163 168,144.244747 168,137.429003 C168,130.518596 167.904763,125.785511 167.714286,123.229607 C167.333331,117.171168 164.761929,114.094663 160,114 C155.238071,114.094663 152.666669,117.171168 152.285714,123.229607 C152.095237,128.341415 152,133.0745 152,137.429003 C152,141.499517 152.095237,146.279932 152.285714,151.770393 C152.666669,157.923495 155.238071,161 160,161 Z M265.762115,188 C264.728336,188 263.83554,187.619051 263.0837,186.857143 C262.331861,186.095234 261.955947,185.190481 261.955947,184.142857 L261.955947,172 L219.806167,172 C218.772388,172 217.879593,171.619051 217.127753,170.857143 C216.375914,170.095234 216,169.190481 216,168.142857 L216,147.714286 C216,146.09523 216.516882,144.619054 217.550661,143.285714 L257.444934,90.4285714 C258.760653,88.8095157 260.499255,88 262.660793,88 L291.982379,88 C293.016158,88 293.908954,88.3809486 294.660793,89.1428571 C295.412632,89.9047657 295.788546,90.8095186 295.788546,91.8571429 L295.788546,143 L308.052863,143 C309.180622,143 310.120407,143.380949 310.872247,144.142857 C311.624086,144.904766 312,145.809519 312,146.857143 L312,168.142857 C312,169.190481 311.624086,170.095234 310.872247,170.857143 C310.120407,171.619051 309.227612,172 308.193833,172 L295.788546,172 L295.788546,184.142857 C295.788546,185.190481 295.412632,186.095234 294.660793,186.857143 C293.908954,187.619051 293.016158,188 291.982379,188 L265.762115,188 Z M247,145 L263,145 L263,125 L247,145 Z",
                                stroke: "url(#".concat(uniqueID, "Error404-linearGradient-29)")
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "Error404-filter-3)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "Error404-path-2")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "Error404-linearGradient-1)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "Error404-path-2")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "Error404-filter-7)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "Error404-path-6")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "Error404-linearGradient-5)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "Error404-path-6")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(86.000000, 227.000000)",
                                children: [
                                    _jsxs("g", {
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "Error404-filter-11)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "Error404-path-10")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "Error404-linearGradient-9)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "Error404-path-10")
                                            })
                                        ]
                                    }),
                                    _jsx("path", {
                                        d: "M10.7672503,0.844840466 C10.829903,0.884463206 10.8829613,0.937521505 10.922584,1.00017413 L13.7704786,5.50334782 L14.9295943,7.49336008 L15.6255819,7.89010345 L19.9672943,10.5747317 C20.2021635,10.7199593 20.2748324,11.0280886 20.1296048,11.2629579 C20.0888205,11.3289163 20.0332528,11.384484 19.9672943,11.4252683 L15.6255819,14.1098965 L14.9295943,14.5053601 L13.7704786,16.4966522 L10.922584,20.9998259 C10.7749857,21.2332126 10.4661364,21.3027578 10.2327497,21.1551595 C10.170097,21.1155368 10.1170387,21.0624785 10.077416,20.9998259 L7.22952138,16.4966522 L6.06959432,14.5053601 L5.37441809,14.1098965 L1.03270567,11.4252683 C0.966747212,11.384484 0.911179542,11.3289163 0.870395186,11.2629579 C0.725167571,11.0280886 0.797836452,10.7199593 1.03270567,10.5747317 L1.03270567,10.5747317 L5.37441809,7.89010345 L6.06959432,7.49336008 L7.22952138,5.50334782 L10.077416,1.00017413 C10.2250143,0.766787425 10.5338636,0.697242173 10.7672503,0.844840466 Z",
                                        stroke: "url(#".concat(uniqueID, "Error404-linearGradient-12)")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(0.000000, 119.000000)",
                                children: [
                                    _jsxs("g", {
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "Error404-filter-15)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "Error404-path-14")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "Error404-linearGradient-13)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "Error404-path-14")
                                            })
                                        ]
                                    }),
                                    _jsx("path", {
                                        d: "M17.7661364,0.771474961 C17.8296457,0.811405709 17.8833557,0.865115709 17.9232865,0.928625048 L23.0606597,9.09955067 L25.0314271,12.5026958 L26.2148151,13.1814126 L34.0835739,18.0754207 C34.3180626,18.2212619 34.3899255,18.5295802 34.2440843,18.7640689 C34.2035941,18.8291705 34.1486755,18.8840891 34.0835739,18.9245793 L26.2148151,23.8185874 L25.0314271,24.4956958 L23.0606597,27.9004493 L17.9232865,36.071375 C17.7763034,36.3051496 17.4676383,36.3755081 17.2338636,36.228525 C17.1703543,36.1885943 17.1166443,36.1348843 17.0767135,36.071375 L11.9393403,27.9004493 L9.96742709,24.4946958 L8.78518486,23.8185874 L0.916426132,18.9245793 C0.851324546,18.8840891 0.796405937,18.8291705 0.755915729,18.7640689 C0.61007449,18.5295802 0.681937445,18.2212619 0.916426132,18.0754207 L0.916426132,18.0754207 L8.78518486,13.1814126 L9.96742709,12.5036958 L11.9393403,9.09955067 L17.0767135,0.928625048 C17.2236966,0.69485039 17.5323617,0.624491899 17.7661364,0.771474961 Z",
                                        stroke: "url(#".concat(uniqueID, "Error404-linearGradient-16)")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(258.000000, 73.000000)",
                                children: [
                                    _jsxs("g", {
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "Error404-filter-19)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "Error404-path-18")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "Error404-linearGradient-17)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "Error404-path-18")
                                            })
                                        ]
                                    }),
                                    _jsx("path", {
                                        d: "M13.2624863,1.14181456 C13.3288087,1.18272239 13.3846517,1.23856545 13.4255596,1.30488785 L17.3011024,7.588166 L18.8255182,10.2723044 L19.7408031,10.8065316 L25.6891417,14.5777158 C25.9223629,14.7255755 25.9915619,15.0345026 25.8437022,15.2677238 C25.8042117,15.3300126 25.7514305,15.3827938 25.6891417,15.4222842 L19.7408031,19.1934684 L18.8255182,19.7273044 L17.3011024,22.411834 L13.4255596,28.6951122 C13.2805924,28.9301422 12.9725438,29.0031526 12.7375137,28.8581854 C12.6711913,28.8172776 12.6153483,28.7614345 12.5744404,28.6951122 L8.69889761,22.411834 L7.17351819,19.7273044 L6.25919685,19.1934684 L0.310858293,15.4222842 C0.248569493,15.3827938 0.195788264,15.3300126 0.15629782,15.2677238 C0.00843806412,15.0345026 0.0776371448,14.7255755 0.310858293,14.5777158 L0.310858293,14.5777158 L6.25919685,10.8065316 L7.17351819,10.2723044 L8.69889761,7.588166 L12.5744404,1.30488785 C12.7194076,1.06985779 13.0274562,0.99684739 13.2624863,1.14181456 Z",
                                        stroke: "url(#".concat(uniqueID, "Error404-linearGradient-20)")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(94.000000, 27.000000)",
                                children: [
                                    _jsxs("g", {
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "Error404-filter-23)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "Error404-path-22")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "Error404-linearGradient-21)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "Error404-path-22")
                                            })
                                        ]
                                    }),
                                    _jsx("path", {
                                        d: "M13.754854,0.295109513 C13.8270864,0.337903199 13.88738,0.398196784 13.9301737,0.470429183 L17.881279,7.13958623 L19.4334222,9.98520502 L20.3664581,10.5527341 L26.4719598,14.582706 C26.702425,14.7348258 26.7659364,15.0449722 26.6138165,15.2754373 C26.5766002,15.3318209 26.5283435,15.3800777 26.4719598,15.417294 L20.3664581,19.4472659 L19.4334222,20.014205 L17.881279,22.8604138 L13.9301737,29.5295708 C13.7894217,29.7671492 13.4827243,29.8456425 13.245146,29.7048905 C13.1729136,29.6620968 13.11262,29.6018032 13.0698263,29.5295708 L9.11872102,22.8604138 L7.56542222,20.013205 L6.63354194,19.4472659 L0.528040152,15.417294 C0.471656548,15.3800777 0.423399804,15.3318209 0.386183479,15.2754373 C0.234063645,15.0449722 0.297575041,14.7348258 0.528040152,14.582706 L0.528040152,14.582706 L6.63354194,10.5527341 L7.56542222,9.98520502 L9.11872102,7.13958623 L13.0698263,0.470429183 C13.2105783,0.232850804 13.5172757,0.154357514 13.754854,0.295109513 Z",
                                        stroke: "url(#".concat(uniqueID, "Error404-linearGradient-24)")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "Error404-filter-27)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "Error404-path-26")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "Error404-linearGradient-25)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "Error404-path-26")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
Error404.defaultProps = {
    height: 400,
    width: 400
};
export default Error404;
